// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"IFT0b"};